import React, { FC } from 'react';
import { Container } from '@components/atoms/Container';
import { Typography, TypographyAppearanceVariants, TypographyTagVariants } from '@components/atoms/Typography';
import { PromoBasketCard, PromoBasketCardProps } from '../PromoBasketCard';

export interface PromoBasketsListProps {
    title: string;
    titleAlign?: 'left' | 'center' | 'right';
    promoBaskets: PromoBasketCardProps[];
}

export const PromoBasketsList: FC<PromoBasketsListProps> = ({ title, titleAlign, promoBaskets }) => {
    return (
        <Container classes="px-0">
            <>
                <div className="d-block d-md-flex align-items-center mb-4 px-3">
                    <Typography
                        classes="w-100"
                        align={titleAlign || 'left'}
                        tagVariant={TypographyTagVariants.h2}
                        appearanceLevel={TypographyAppearanceVariants.level3}>
                        {title}
                    </Typography>
                </div>
                <div className="container-fluid">
                    <div className="row row-gap-4 pt-2">
                        {promoBaskets.map((item, index) => (
                            <div key={`promo-basket-${index}`} className="col-12 col-md-4 col-xxl-4">
                                <PromoBasketCard {...item} />
                            </div>
                        ))}
                    </div>
                </div>
            </>
        </Container>
    );
};
